import { Component, OnInit } from '@angular/core';
// import mermaid from 'mermaid';


@Component({
    selector: 'app-data-transform-visualizer',
    templateUrl: './data-transform-visualizer.component.html',
    styleUrls: ['./data-transform-visualizer.component.css'],
    standalone: false
})
export class DataTransformVisualizerComponent implements OnInit {
  flowChart: any;
  stringFlowChart: any = '';

  constructor() { }

  ngOnInit(): void {
    // this.createFlowchart();
    // mermaid.initialize({});
    // mermaid.init();
  }

  createFlowchart(): void {
    this.flowChart = [
       'graph TD',
        'id1[Ingest] & id2[Ingest 2]',
        'id1 & id2 --> id3[Subtasks]',
        'id3 --> id4[Grouper]',
        'id4 --> id5[Activity Namer]',
        'id5 --> id6[Subtask Namer]',
        'id6 --> id7[Tasks]',
        'id7 --> id8[Task Namer] --> id7[End]'
    ];
    this.stringFlowChart = this.flowChart.join('\n');
  }
 }


